import * as $ from 'jquery';
import { Component, OnInit, ViewChild, AfterViewInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { FilterOption } from '../../../common/components/filter/filter-model';
import { ControlType } from '../../../common/components/filter/filter-enum';
import { LoaderService } from '../../../services/infrastructure/loader.service';
import { LocalStorageService } from '../../../services/infrastructure/local-storage.service';
import { ToastrService } from 'ngx-toastr';
import { SubscriptionManagementService } from '../../../services/subscription-management/subscription-management.service';
import { CommonService } from '../../../services/common/common.service';
import { MasterConstants } from '../../../common/constants/master-constants';
import { CppPriceListService } from '../../../services/cpp/cpp-price-list.service';

@Component({
  selector: 'app-subscription-landing-page',
  templateUrl: './subscription-landing-page.component.html',
  styleUrls: ['./subscription-landing-page.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SubscriptionLandingPageComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  selectedTabIndex = 0;
  filterOptionsData: Array<FilterOption>;
  subscription = new Subscription();
  filter: any = {};
  mySubscriptionUserIDGroupingData: any = [];
  mySubscriptionAccountGroupingData: any;
  selectedUsers = 0;
  isShowManageSub = false;
  headerCompany = MasterConstants.US_COMPANYCODE;
  globalSubscriptionData: any = [];
  headerYear: any;
  isCPPPriceListAccess = false;
  userMenuAccessList: any;
  cppPriceAccounts: any;
  isPushPinClicked = false;
  isExportDisabled = false;
  isGroupByUserId = true;
  manageSubscriptionUserIdGroupingData: any = [];
  manageSubscriptionAccountGroupingData: any = [];
  tab0Data: any = null;
  tab1Data: any = null;
  isTab0DataFetched: boolean = false;
  isTab1DataFetched: boolean = false;
  constructor(
    private router: Router,
    private loaderService: LoaderService,
    private subscriptionManagementService: SubscriptionManagementService,
    private toastrService: ToastrService,
    private localStorageService: LocalStorageService,
    private commonService: CommonService,
    private cppPriceListService: CppPriceListService

  ) { }

  ngOnInit(): void {
    this.isCPPPriceListAccess = this.commonService.checkUserRoleAccessTypeForMenu(null, MasterConstants.FUNCTION_CODE.CROP_PROTECTION_PRODUCT_PRICE_LIST);
    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.headerYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    }
    this.setDefaultFilter();
    this.showManageSub();
    this.setFilterAndGridColumn();
    this.setDropDownValues();
  }

  // Set Filter and Grid Columns
  setFilterAndGridColumn() {
    this.filterOptionsData = [
      { label: 'Account Name', key: 'accountName', controlType: ControlType.Text, },
      { label: 'Account Number', key: 'accountNumber', controlType: ControlType.Integer, },
      { label: 'City', key: 'city', controlType: ControlType.Text, },
      { label: 'State', key: 'state', controlType: ControlType.DropDown, controlDataBindLabel: 'value', controlDataBindValue: 'id' },
      { label: 'Parent Account Name', key: 'parentAccountName', controlType: ControlType.Text, },
      { label: 'Parent Account Number', key: 'parentAccountNumber', controlType: ControlType.Integer, },
      { label: 'User ID', key: 'UserIdList', controlType: ControlType.DropDown, controlDataBindLabel: 'value', controlDataBindValue: 'id' },
      { label: 'User Name', key: 'UserNameList', controlType: ControlType.ValuesWithIDDropDown, controlDataBindLabel: 'value', controlDataBindValue: 'id' },
      { label: 'User Role', key: 'UserRoleList', controlType: ControlType.DropDown, controlDataBindLabel: 'value', controlDataBindValue: 'value' },
      { label: 'Subscription Type', key: 'SubscriptionTypeList', controlType: ControlType.DropDown, controlDataBindLabel: 'value', controlDataBindValue: 'id' },
    ];
  }

  // Set Drop down values for filter
  setDropDownValues(tabData?:any) {
    // State data
    if (!tabData) {
      this.subscription.add(this.commonService.getFilterDDLData().subscribe((result: any) => {
        if (result && result.states) {
          this.filterOptionsData.find(x => x.key === 'state').controlData = result.states;
        }
      }));

      // For UserRoles filter
      this.subscription.add(this.subscriptionManagementService.getSubscriptionRoleList().subscribe((result: any) => {
        if (result) {
          this.filterOptionsData.find(x => x.key === 'UserRoleList').controlData = result;
        }
      }));

      // For Subscription Types filter
      this.subscription.add(this.subscriptionManagementService.getSubscriptionTypeList().subscribe((result: any) => {
        if (result) {
          this.filterOptionsData.find(x => x.key === 'SubscriptionTypeList').controlData = result;
        }
      }));
    }
    if (tabData) {
        const userIds: any[] = [];
        const userNames: any[] = [];
        if (this.selectedTabIndex == 0) {
          for (var i = 0; i < tabData.mySubscriptionUserIDGroupingVM.length; i++) {
            userIds.push({
              id: tabData.mySubscriptionUserIDGroupingVM[i].userID,
              value: tabData.mySubscriptionUserIDGroupingVM[i].userID
            });
            userNames.push({
              id: tabData.mySubscriptionUserIDGroupingVM[i].legalName,
              value: tabData.mySubscriptionUserIDGroupingVM[i].userName
            });
          }
        }
        else {
          const uniqueUserIds: any[] = [...new Set(tabData.manageSubscriptionUserIDGroupingVM.map(x => x.userID))];
          const userNameDrpDwn: any[] = tabData.manageSubscriptionUserIDGroupingVM.map(obj => ({ userName: obj.userName, legalName: obj.legalName, userID: obj.userID }))
          for (var i = 0; i < uniqueUserIds.length; i++) {
            userIds.push({
              id: uniqueUserIds[i],
              value: uniqueUserIds[i]
            });
          }
          for (var i = 0; i < userNameDrpDwn.length; i++) {
            userNames.push({
              id: userNameDrpDwn[i].legalName,
              value: userNameDrpDwn[i].userName + "(" + userNameDrpDwn[i].userID + ")"
            });
          }
        }
        this.filterOptionsData.find(x => x.key === 'UserIdList').controlData = userIds;
        this.filterOptionsData.find(x => x.key === 'UserNameList').controlData = userNames;
      }
  }

  toggleGroupBy() {
    this.isGroupByUserId = !this.isGroupByUserId;
    this.globalSubscriptionData = [];
    this.selectedUsers = 0;
    this.setDefaultGrid();
  }

  redirectToCPPProductsOrPrice() {
    this.loaderService.setLoaderStatus(true);
    if (this.cppPriceAccounts && this.cppPriceAccounts.length === 1) {
      this.cppPriceListService.accountName = this.cppPriceAccounts[0].accountName;
      const accountNumber = this.cppPriceAccounts[0].accountNumber;
      this.router.navigate(['/cpp/price-list-dashboard/' + accountNumber]);
    } else {
      this.router.navigate(['/cpp/customer-price-list']);
    }
  }
  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setAccSummaryTableHeight();
  }

  showManageSub() {
    this.loaderService.setLoaderStatus(true);
    this.subscription.add(this.subscriptionManagementService.checkManageSubAvailibility().subscribe((result: any) => {
      this.isShowManageSub = result;
      this.getGridData(false);
      // this.loaderService.setLoaderStatus(false);
    },
      (error) => {
        this.loaderService.setLoaderStatus(false);
      }
    )
    );
  }
  getGridData(isFirstLevelExpand: boolean) {
    this.loaderService.setLoaderStatus(true);
    this.subscription.add(this.subscriptionManagementService.getLandingGridList({ ...this.filter, TabIndex: this.selectedTabIndex }).subscribe((result: any) => {

      if (this.selectedTabIndex === 0 && !this.isTab0DataFetched) {
        this.tab0Data = result;
        this.isTab0DataFetched = true;
      }
      else if (this.selectedTabIndex === 1 && !this.isTab1DataFetched) {
        this.tab1Data = result;
        this.isTab1DataFetched = true; 
      }

      this.isExportDisabled = result.isExportDisabled;

      // Set default global Subscription and selected user
      this.globalSubscriptionData = [];
      this.selectedUsers = 0;

      // My Subscription tab variables.
      if (this.selectedTabIndex == 0) {
        this.GetMySubscriptionTabGridData(result, isFirstLevelExpand);
        this.setDropDownValues(this.tab0Data);
      }
      // Manage Subscription tab variables.
      if (this.selectedTabIndex == 1) {
        this.GetManageSubscriptionTabGridData(result, isFirstLevelExpand);
        this.setDropDownValues(this.tab1Data);
      }

      this.loaderService.setLoaderStatus(false);
    },
      (error) => {
        this.loaderService.setLoaderStatus(false);
      }
    )
    );
  }

  GetMySubscriptionTabGridData(result: any, isFirstLevelExpand: boolean) {
    result.mySubscriptionUserIDGroupingVM.map((item) => {
      item.isFirstLevelExpanded = isFirstLevelExpand ? true : false;
      item.isChecked = false;
      item.isPushPinClicked = false;
      item.mySubscriptionAccountsVM.map((account) => {
        account.isChecked = false;
      });
    });

    result.mySubscriptionAccountGroupingVM.map((item) => {
      item.isFirstLevelExpanded = isFirstLevelExpand ? true : false;
      item.isChecked = false;
      item.isPushPinClicked = false;
      item.mySubscriptionAccountUserVM.map((user) => {
        user.isChecked = false;
      });
    });

    this.mySubscriptionUserIDGroupingData = result.mySubscriptionUserIDGroupingVM;
    this.mySubscriptionAccountGroupingData = result.mySubscriptionAccountGroupingVM;
  }

  GetManageSubscriptionTabGridData(result: any, isFirstLevelExpand: boolean) {
    result.manageSubscriptionUserIDGroupingVM.map((item) => {
      item.isFirstLevelExpanded = isFirstLevelExpand ? true : false;
      item.isChecked = false;
      item.isPushPinClicked = false;
      item.mySubscriptionAccountsVM.map((account) => {
        account.isChecked = false;
      });
    });

    result.manageSubscriptionAccountGroupingVM.map((item) => {
      item.isFirstLevelExpanded = isFirstLevelExpand ? true : false;
      item.isChecked = false;
      item.isPushPinClicked = false;
      item.mySubscriptionAccountUserVM.map((user) => {
        user.isChecked = false;
      });
    });
    this.manageSubscriptionUserIdGroupingData = result.manageSubscriptionUserIDGroupingVM;
    this.manageSubscriptionAccountGroupingData = result.manageSubscriptionAccountGroupingVM;
  }

  // Set default filter values
  setDefaultFilter() {
    this.filter = {
      AccountName: null,
      AccountNumber: null,
      City: null,
      State: null,
      userId: null,
      UserName: null,
      userRole: null,
      ParentAccountName: null,
      ParentAccountNumber: null,
      UserIdList: null,
      UserNameList: null,
      UserRoleList: null,
      SubscriptionTypeList: null,
    };
  }

  // Tab changed
  tabChanged = (tabChangeEvent: MatTabChangeEvent): void => {
    this.selectedTabIndex = tabChangeEvent.index;
    this.setAccSummaryTableHeight();
    this.getGridData(false);
    this.setDropDownValues();
  };

  setDefaultGrid() {
    if (this.selectedTabIndex == 0) {
      this.GetMySubscriptionTabGridData({ 'mySubscriptionUserIDGroupingVM': this.mySubscriptionUserIDGroupingData, 'mySubscriptionAccountGroupingVM': this.mySubscriptionAccountGroupingData }, false);
    }
    if (this.selectedTabIndex == 1) {
      this.GetManageSubscriptionTabGridData({ 'manageSubscriptionUserIDGroupingVM': this.manageSubscriptionUserIdGroupingData, 'manageSubscriptionAccountGroupingVM': this.manageSubscriptionAccountGroupingData }, false);
    }
  }
  // set account table height
  setAccSummaryTableHeight() {
    setTimeout(function () {
      const templateHeight =
        window.innerHeight -
        $('.TopSec').outerHeight() -
        $('.form-sec').outerHeight() -
        $('.mat-tab-header').outerHeight() -
        $('.fulfill-top-sec').outerHeight() -
        250;
      $('.activeReturnRequest').css('max-height', templateHeight + 'px');
      $('.draftReturnRequest').css('max-height', templateHeight + 'px');
    }, 100);
  }

  // Search Action
  filterSearchClick(event) {
    this.filter = event;
    this.getGridData(true);
  }

  onSubscribeEmail(data: any): void {
    let isBindGrid = false;
    if (this.selectedTabIndex == 0) { isBindGrid = true; }
    this.saveSubscriptions(data, isBindGrid);
  }

  onSetGlobalSubscriptionData(data: any) {
    console.log('[Parent] SetGlobalSubscriptionData event:', data);

    let isFind = false;
    isFind = this.globalSubscriptionData.find((item) => {
      if (item.userID == data.userID && item.accountNumber == data.accountNumber) {
        item.isSelected = data.isSelected;
        return true;
      }
    });
    if (!isFind) {
      this.globalSubscriptionData.push(data);
    }
    const selectedAccounts = this.globalSubscriptionData.filter(value => value.isSelected === true).length;
    this.selectedUsers = selectedAccounts;
  }

  onGlobalSubscriptionClick(subscriptionList: any) {
    const finalData = [];
    subscriptionList.map((subscription) => {
      this.globalSubscriptionData.map((item) => {
        if (item.isSelected) {
          finalData.push({
            userID: item.userID, accountNumber: item.accountNumber, subscriptionTypeID: subscription.subscriptionTypeID, isActive: subscription.isServerSideChecked, isFavouriteChecked: subscriptionList[0].isFavouriteChecked,
            isStopLightChecked: subscription.isStopLightChecked, tabIndex: this.selectedTabIndex, subscriptionSuplementId: subscription.subscriptionSuplementId
          });
        }
      });
    });
    this.saveSubscriptions(finalData, true);
  }

  saveSubscriptions(data: any, bindGrid: boolean) {
    this.loaderService.setLoaderStatus(true);
    this.subscription.add(
      this.subscriptionManagementService.saveSubscriptions(data).subscribe(
        (result: any) => {
          this.loaderService.setLoaderStatus(false);
          if (result.status) {
            if (bindGrid) { this.getGridData(true); }
            this.toastrService.success(result.message);
          }
          else {
            this.toastrService.error(result.message);
          }
        },
        (error) => {
          this.loaderService.setLoaderStatus(false);
          this.toastrService.error(error);
        }
      )
    );
  }

  // Clear All Action
  filterClearAllClick(event) {
    this.filter = event;
    this.getGridData(true);
  }

  export() {
    this.loaderService.setLoaderStatus(true);
    this.subscription.add(
      this.subscriptionManagementService.getSubscriptionDataForExport({ ...this.filter, TabIndex: this.selectedTabIndex }).subscribe(result => {
        this.subscriptionManagementService.base64toFile(result.base64, result.mimeType, result.fileName);
        this.loaderService.setLoaderStatus(false);
      },
        (error) => {
          this.loaderService.setLoaderStatus(false);
        }
      )
    );
  }

  // ngOnDestroy
  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
